import { render, staticRenderFns } from "./InputMultiSelect.vue?vue&type=template&id=dca50482&scoped=true"
import script from "./InputMultiSelect.vue?vue&type=script&lang=js"
export * from "./InputMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./InputMultiSelect.vue?vue&type=style&index=0&id=dca50482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca50482",
  null
  
)

export default component.exports